// Búsqueda tolerante a acentos, mayúsculas y orden de palabras.
// Pedido del cliente 2026-08-20: el staff no encontraba a la gente cuando el
// nombre tenía acentos ("José" vs "Jose") o segundo nombre ("Jorge E. Cruz").

// Quita los acentos (José -> Jose, Muñoz -> Munoz)
export const stripAccents = (v) => String(v ?? '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '');

// Sin acentos ni mayúsculas, para comparar
export const normalizeSearch = (v) => stripAccents(v).toLowerCase();

// Un token es "de teléfono" solo si es puramente numérico (con la puntuación
// típica de un teléfono). Antes CUALQUIER token caía al comparador de
// dígitos: buscar el email "carlos1985@gmail.com" sacaba los dígitos "1985"
// y matcheaba a cualquier otra persona cuyo teléfono o licencia los tuviera
// — el staff escribía un email y le salía otra persona (reporte 2026-09-10).
const isPhoneToken = (t) => /^[\d\s().+-]+$/.test(t) && t.replace(/\D/g, '').length >= 3;

// Cada palabra escrita debe aparecer en ALGÚN campo, en cualquier orden.
// "jorge cruz" encuentra "Jorge E. Fernández Cruz"; los teléfonos se comparan
// también solo por dígitos, así que "7879958134" encuentra "(787) 995-8134".
export const matchesSearch = (query, fields = []) => {
  const tokens = normalizeSearch(query).split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const haystack = normalizeSearch(fields.filter(Boolean).join(' '));
  const digits = String(fields.filter(Boolean).join(' ')).replace(/\D/g, '');
  return tokens.every((t) => {
    if (haystack.includes(t)) return true;
    return isPhoneToken(t) && digits.includes(t.replace(/\D/g, ''));
  });
};
